import { pathgen } from 'object-path-generator';
export const DropdownMenuItemTestIds = pathgen('DropdownMenuItemTestIds');